module.exports = __webpack_public_path__ + "static/media/mealshare-app.3ecfa9b1.png";